import React from 'react'

/**
 * Inline error surface used across detail pages. When the caller provides
 * an `onRetry` callback, a Retry button is rendered for keyboard /
 * pointer recovery instead of forcing a page reload.
 */
export default function ErrorBox({
  error,
  onRetry,
  retryLabel = 'Retry',
}: {
  error: any
  onRetry?: () => void
  retryLabel?: string
}) {
  const msg = (error && (error.message || String(error))) || 'Unknown error'
  return (
    <div
      className="card"
      role="alert"
      aria-live="polite"
      style={{ borderColor: 'rgba(248, 113, 113, 0.35)', background: 'rgba(248, 113, 113, 0.08)' }}
    >
      <div className="row" style={{ alignItems: 'flex-start', gap: 10, justifyContent: 'space-between' }}>
        <div className="mono" style={{ color: 'var(--bad)', minWidth: 0, flex: 1 }}>{msg}</div>
        {onRetry ? (
          <button type="button" className="btn" onClick={onRetry} aria-label={retryLabel}>
            {retryLabel}
          </button>
        ) : null}
      </div>
    </div>
  )
}
